module.exports = __webpack_public_path__ + "img/analysis_parttwo_wholescreen.570856de.svg";